// extracted by mini-css-extract-plugin
export var changeIcon = "_5v-4";
export var container = "_5v-0";
export var divider = "_5v-7";
export var externalLinkIcon = "_5v-1";
export var green = "_5v-5";
export var helpCircleIcon = "_5v-3";
export var iconButton = "_5v-2";
export var red = "_5v-6";